import React from 'react';
import { withFormsy } from 'formsy-react';
import { TextField } from 'react-md';

import './MyInput.scss';
class MyInput extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(val='') {
    // setValue() will set the value of the component, which in
    // turn will validate it and the rest of the form
    // Important: Don't skip this step. This pattern is required
    // for Formsy to work.
    this.props.setValue(val);
  }

  render() {
    // An error message is passed only if the component is invalid
    const {error, errorText, name, id, type, label, placeholder, value, validations, autoComplete} = this.props;

    return (
      <>
        {/* fake fields are a workaround for chrome/opera autofill getting the wrong fields*/}
        <input id={`fake${name}`} style={{ display: 'none', }} type={type} name={`fake${name}remembered`} />
        <TextField
          name={name}
          id={id}
          type={type}
          label={label}
          onChange={this.changeValue}
          placeholder={placeholder}
          value={value || ''}
          error={error}
          errorText={errorText}
          fullWidth
          rightIconStateful
          autoComplete={autoComplete}
          validations={validations}
        />
      </>
    );
  }
}

export default withFormsy(MyInput);
